import script from "./Catalogue.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogue.vue?vue&type=script&setup=true&lang=js"

import "./Catalogue.vue?vue&type=style&index=0&id=566a561f&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566a561f"]])

export default __exports__